export const STORY_BOOK = {
  CARD_ID: '1',
  CARD_BILL_ID: '1',
  COMMENT_TEMPLATE_ID: 1,
  EMAIL: 'xxxx@up-sider.com',
  FREEE_COMPANY_ID: '100',
  ID: '100',
  LOCAL_STORAGE_USER_KEY: 'user',
  ORGANIZATION_ID: '100',
  ORGANIZATION_NAME: 'TEST株式会社',
  USER_ID: '1',
  USER_NAME: 'TEST太郎',
  USER_ACCOUNT_ID: '100',
  PAYMENT_REFERENCE_ID: '100',
  MERCHANT_ID: '1',
  PURCHASE_TEMPLATE_ID: '1',
  PAYMENT_REQUEST_ID: '1',
  TO_YEAR_MONTH: '202101',
  UPSIDER_COWORKER_AGREEMENT_REQUEST_ID: '1',
  EXTINGUISHMENT_OF_GUARANTEE_MONEY_AGREEMENT_REQUEST_ID: '2',
  UPSIDER_COWORKER_WITH_SUPPORT_OPTION_AGREEMENT_REQUEST_ID: '3',
  EVIDENCE_ID: '1',
  CHANNEL_ID: 'C0000000001',
  CURRENT_CHANNEL_ID: 'C0000000002',
  BANK_ACCOUNT_ID: 'test_bank_account_id_01',
  BANK_TRANSFER_ID: '1',
  FREEE_CONNECTED_AT: '2023-01-01T00:00:00.000Z',
  FREEE_RECONNECTION_REQUIRED_CONNECTED_AT: '2022-01-01T00:00:00.000Z',
  PAYMENT_REQUEST_IDS: ['payment_request_id_01', 'payment_request_id_02'],
  VISA_TRANSACTION_REFERENCE_ID: '1',
  CARD_TRANSACTION_COMMENT_ID: '1',
  CARD_TRANSACTION_COMMENT_COMMENT: 'test',
  ROLE_RESOURCE_ID: '1',
  ROLE_RESOURCE_SCOPE: 'USER_ACCOUNT_GROUP',
  USER_ACCOUNT_GROUP_ID: '1',
  USER_MESSAGE_ID: '1',
  TEAMS_CHANNEL_ID: 'TESTCHID1',
  TRUSTDOCK_IDENTIFICATION_ID: 'acbdefghi-jklm-nopq-rstuvwxyz',
  USAGE_FEE_ID: '1',
}
